export const GET_RESOURCE_CATEGORIES = 'GET_RESOURCE_CATEGORIES'
export const GET_RESOURCE_CATEGORY = 'GET_RESOURCE_CATEGORY'
export const ADD_RESOURCE_CATEGORY = 'ADD_RESOURCE_CATEGORY'
export const UPDATE_RESOURCE_CATEGORY = 'UPDATE_RESOURCE_CATEGORY'
export const DELETE_RESOURCE_CATEGORY = 'DELETE_RESOURCE_CATEGORY'
